// Next Diamonds - Price Discount Display
// Reads window.ndPromo.discountPercent. Rewrites Symmetry's price block to show
// strikethrough original + discounted, AND inserts a wide "You save" banner
// below the price block. Re-runs on variant change.

(function () {
  'use strict';

  function getDiscount() {
    var promo = window.ndPromo || {};
    var pct = parseFloat(promo.discountPercent);
    if (isNaN(pct) || pct <= 0 || pct >= 100) return 0;
    return pct;
  }

  function findPriceBlock() {
    return (
      document.querySelector('.product-info .price') ||
      document.querySelector('.product-info__price .price') ||
      document.querySelector('.price-container .price') ||
      document.querySelector('.price') ||
      null
    );
  }

  function findCurrentPriceEl(block) {
    return (
      block.querySelector('.price__current') ||
      block.querySelector('.price__default .price__current') ||
      block.querySelector('.price__regular .price-item--regular') ||
      block.querySelector('.price-item--regular') ||
      null
    );
  }

  function parseAmount(text) {
    var m = text.replace(/\s+/g, ' ').match(/([\$£€¥₹]?)\s?([\d,]+(?:\.\d+)?)/);
    if (!m) return null;
    return {
      symbol: m[1] || '$',
      amount: parseFloat(m[2].replace(/,/g, ''))
    };
  }

  function format(symbol, amount) {
    return symbol + amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function init() {
    var pct = getDiscount();
    if (pct === 0) return;

    var block = findPriceBlock();
    if (!block) return;
    var priceEl = findCurrentPriceEl(block);
    if (!priceEl) return;

    var defaultWrap = block.querySelector('.price__default') || priceEl.parentElement;

    // Discounted price element (large, primary)
    var discountedEl = document.createElement('span');
    discountedEl.className = 'nd-price-discounted';
    discountedEl.setAttribute('data-nd-price-discounted', '');
    defaultWrap.insertBefore(discountedEl, priceEl);

    // Save banner placed directly after the price block — transparent, red text
    var saveBanner = document.createElement('div');
    saveBanner.className = 'nd-price-save-banner';
    saveBanner.innerHTML = '<span class="nd-price-save-banner__main" data-nd-save-amount></span>' +
      '<span class="nd-price-save-banner__sep">|</span>' +
      '<span class="nd-price-save-banner__pct">' + Math.round(pct) + '%</span>';
    block.parentNode.insertBefore(saveBanner, block.nextSibling);
    var saveAmountEl = saveBanner.querySelector('[data-nd-save-amount]');

    function update() {
      var parsed = parseAmount(priceEl.textContent || '');
      if (!parsed) {
        block.classList.remove('has-discount');
        saveBanner.style.display = 'none';
        return;
      }
      var newAmount = parsed.amount * (1 - pct / 100);
      var savings = parsed.amount - newAmount;
      discountedEl.textContent = format(parsed.symbol, newAmount);
      if (saveAmountEl) saveAmountEl.textContent = 'Save ' + format(parsed.symbol, Math.round(savings));
      block.classList.add('has-discount');
      saveBanner.style.display = '';
    }

    update();

    var observer = new MutationObserver(function () { update(); });
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
